import { cn } from "@/lib/utils";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from "@/components/ui/sidebar";
import GrantFilters from "./GrantFilters";
import SortBy from "../../ui/SortBy";
import SearchFilter from "../../ui/filter/SearchFilter";
import {
  contractTypes,
  naicsCodes,
  departments,
  dueDateFilters,
  postedDateFilters,
  setAsideCode,
  SledLevel,
  UsJurisdictions,
  UsStates,
} from "./FilterValues";
import { useContext } from "react";
import { SearchContext } from "../../pages/Search";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CollapsibleFilter } from "../../ui/filter/CollapsibleFilter";
import { toPascalCase } from "../../utils/helpers";
import DateFilter from "../../ui/filter/DateFilter";
import SbirFilters from "./SbirFilters";

function FederalFilters({ className, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-8", className)} {...props}>
      <DateFilter
        title={"Due Date"}
        filters={dueDateFilters}
        urlName="Deadline"
        defaultFilter="Active only"
      />
      <DateFilter
        title={"Posted Date"}
        filters={postedDateFilters}
        urlName="PostedDateInt"
      />
      <CollapsibleFilter
        title={"Contract Type"}
        urlName="Type"
        items={contractTypes}
      />
      <SearchFilter
        title={"Set Aside Code"}
        urlName="SetASideCode"
        placeholder="Ex: WOSB"
        items={setAsideCode}
      />
      <SearchFilter
        title={"NAICS Codes"}
        urlName="NaicsCode"
        placeholder="Ex: 541511"
        items={naicsCodes.map((naics) => ({
          keys: [naics.code.toString()],
          label: `${naics.code} - ${naics.name}`,
        }))}
        topK={20}
      />
      <SearchFilter
        title={"Department / Agency"}
        urlName="Department/Ind.Agency"
        placeholder="Ex: Department of Agriculture"
        items={departments.map((department) => toPascalCase(department))}
      />
    </div>
  );
}
function SledFilters({ className, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-4", className)} {...props}>
      <SearchFilter
        title={"State"}
        urlName="state"
        placeholder="Ex: California"
        items={UsStates}
      />
      <CollapsibleFilter title={"Level"} urlName="level" items={SledLevel} />
      <SearchFilter
        title={"Jurisdiction"}
        urlName="jurisdiction"
        placeholder="Ex: Washington County"
        items={UsJurisdictions}
      />
    </div>
  );
}
function Filters() {
  const { searchType } = useContext(SearchContext);
  if (searchType === "federal") {
    return <FederalFilters />;
  } else if (searchType === "sled") {
    return <SledFilters />;
  } else if (searchType === "grant") {
    return <GrantFilters />;
  } else if (searchType === "sbir") {
    return <SbirFilters />;
  }
}

export default function FilterSidebar() {
  return (
    <Sidebar side="right" className="">
      <SidebarContent className="py-8 px-3">
        <ScrollArea>
          <SidebarGroup>
            <SidebarGroupLabel className="text-xl text-secondary-foreground font-semibold px-0 mb-2">
              Sort
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SortBy
                id="search-filter-sort"
                defaultValue={"relevance-desc"}
                options={[
                  { value: "relevance-desc", label: "Sort by relevance" },
                  {
                    value: "due-desc",
                    label: "Sort by latest deadline",
                  },
                  {
                    value: "due-asc",
                    label: "Sort by earliest deadline",
                  },
                  {
                    value: "posted-desc",
                    label: "Sort by most recent posting",
                  },
                  { value: "posted-asc", label: "Sort by oldest posting" },
                ]}
              />
            </SidebarGroupContent>
          </SidebarGroup>
          <SidebarGroup>
            <SidebarGroupLabel className="text-xl text-secondary-foreground font-semibold px-0 mb-2">
              Filter
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <Filters className="" />
            </SidebarGroupContent>
          </SidebarGroup>
        </ScrollArea>
      </SidebarContent>
    </Sidebar>
  );
}
